module.exports = __webpack_public_path__ + "static/progression_tree_screen-6aa18a3e35b87971381281d854a21202.png";